/**
 * Shared ComplexFilter / wrapper-insights helpers for Optimizer V2 pages.
 */

import { ruleItemInjector } from "../Quadrant/quadrantHelper";

export function prepareWrapperFilters(filters = {}) {
  return { filters: filters || {}, isEmptyMatch: false };
}

export function buildSearchRuleItems(searchText, dimensionMembers = []) {
  const trimmed = (searchText || "").trim();
  if (!trimmed || !dimensionMembers?.length) return [];
  return dimensionMembers.map((member) => ({
    type: "RULE_ITEM",
    member,
    operator: "contains",
    values: [trimmed],
  }));
}

/**
 * Inject top-search OR rules under filters.dimensions.
 */
export function injectSearchIntoFilters(
  filters,
  searchText,
  dimensionMembers = []
) {
  const searchRuleItems = buildSearchRuleItems(searchText, dimensionMembers);
  if (!searchRuleItems.length) return filters || {};
  return ruleItemInjector(
    filters || {},
    "dimensions",
    searchRuleItems,
    "OR_RULE"
  );
}

export function isCampaignTypeSP(campaignType) {
  return campaignType === "SP";
}

export function isCampaignTypeSB(campaignType) {
  return typeof campaignType === "string" && campaignType.includes("SB");
}

export const SB_SD_OPTIMISATION_TOOLTIP = "SB/SD optimisation not supported";
export const SB_SD_OPTIMISATION_MODAL_NOTE =
  "SB/SD rows are not supported and will be ignored.";

/** Force SP-only rows for ALL_MATCHING / ALL_MATCHING_EXCEPT bulk ops. */
export function injectSpCampaignTypeFilter(filters = {}) {
  return ruleItemInjector(
    filters || {},
    "dimensions",
    [
      {
        type: "RULE_ITEM",
        member: "campaign_type",
        operator: "equals",
        values: ["SP"],
      },
    ],
    "AND_RULE"
  );
}

/**
 * Generic wrapper insights query body builder.
 * Pages pass alwaysMeasures / extra query fields as needed.
 */
export function buildWrapperInsightsQueryBody({
  queryDimensions = [],
  filters = {},
  queryMeasure = [],
  alwaysMeasures = [],
  queryOrder = [["spends", "desc"]],
  timeDimensions = [],
  dateRange,
  offset = 0,
  limit = 50,
  extraQueryFields = {},
}) {
  const measures = [
    ...new Set([...(queryMeasure || []), ...(alwaysMeasures || [])]),
  ];

  const resolvedTimeDimensions =
    timeDimensions?.length > 0
      ? timeDimensions
      : dateRange
        ? [{ dimension: "date", dateRange }]
        : [];

  return {
    query: {
      dimensions: queryDimensions,
      filters: filters || {},
      measures,
      order: queryOrder,
      timeDimensions: resolvedTimeDimensions,
      offset,
      limit,
      ...extraQueryFields,
    },
  };
}

export function clearAllSelections(rows = []) {
  return (rows || []).map((row) => ({ ...row, isChecked: false }));
}
